/**
 * Returns a Contentful video URL with the corresponding protocol.
 */
export const getContentfulVideoUrl = (baseUrl: string) => {
  return baseUrl.startsWith('//') ? `https:${baseUrl}` : baseUrl;
};
